/* Countries list */

let CountriesList = {
	AF: {
		CountryCode: "+93",
		CountryName: "Afghanistan",
		ISO_2Code: "AF",
		ISO_3Code: "AFG",
		CountryName_ar: "افغانستان"
	},
	AD: {
		CountryCode: "+376",
		CountryName: "Andorra",
		ISO_2Code: "AD",
		ISO_3Code: "AND",
		CountryName_ar: "أندورا"
	},
	AE: {
		CountryCode: "+971",
		CountryName: "United Arab Emirates",
		ISO_2Code: "AE",
		ISO_3Code: "ARE",
		CountryName_ar: "الإمارات العربية المتحدة"
	},
	AU: {
		CountryCode: "+61",
		CountryName: "Australia",
		ISO_2Code: "AU",
		ISO_3Code: "AUS",
		CountryName_ar: "أستراليا"
	},
	AT: {
		CountryCode: "+43",
		CountryName: "Austria",
		ISO_2Code: "AT",
		ISO_3Code: "AUT",
		CountryName_ar: "النمسا"
	},
	BS: {
		CountryCode: "+1",
		CountryName: "Bahamas",
		ISO_2Code: "BS",
		ISO_3Code: "BHS",
		CountryName_ar: "الباهاماس"
	},
	BH: {
		CountryCode: "+973",
		CountryName: "Bahrain",
		ISO_2Code: "BH",
		ISO_3Code: "BHR",
		CountryName_ar: "البحرين"
	},
	BD: {
		CountryCode: "+880",
		CountryName: "Bangladesh",
		ISO_2Code: "BD",
		ISO_3Code: "BGD",
		CountryName_ar: "بنغلاديش"
	},
	BE: {
		CountryCode: "+32",
		CountryName: "Belgium",
		ISO_2Code: "BE",
		ISO_3Code: "BEL",
		CountryName_ar: "بلجيكا"
	},
	BM: {
		CountryCode: "+1",
		CountryName: "Bermuda",
		ISO_2Code: "BM",
		ISO_3Code: "BMU",
		CountryName_ar: "جزر برمودا"
	},
	BT: {
		CountryCode: "+975",
		CountryName: "Bhutan",
		ISO_2Code: "BT",
		ISO_3Code: "BTN",
		CountryName_ar: "بوتان"
	},
	BR: {
		CountryCode: "+55",
		CountryName: "Brazil",
		ISO_2Code: "BR",
		ISO_3Code: "BRA",
		CountryName_ar: "البرازيل"
	},
	BN: {
		CountryCode: "+673",
		CountryName: "Brunei Darussalam",
		ISO_2Code: "BN",
		ISO_3Code: "BRN",
		CountryName_ar: "Brunei Darussalam"
	},
	KH: {
		CountryCode: "+855",
		CountryName: "Cambodia",
		ISO_2Code: "KH",
		ISO_3Code: "KHM",
		CountryName_ar: "كمبوديا"
	},
	CA: {
		CountryCode: "+1",
		CountryName: "Canada",
		ISO_2Code: "CA",
		ISO_3Code: "CAN",
		CountryName_ar: "كندا"
	},
	CN: {
		CountryCode: "+86",
		CountryName: "China",
		ISO_2Code: "CN",
		ISO_3Code: "CHN",
		CountryName_ar: "الصين"
	},
	CO: {
		CountryCode: "+57",
		CountryName: "Colombia",
		ISO_2Code: "CO",
		ISO_3Code: "COL",
		CountryName_ar: "كولومبيا"
	},
	CR: {
		CountryCode: "+506",
		CountryName: "Costa Rica",
		ISO_2Code: "CR",
		ISO_3Code: "CRI",
		CountryName_ar: "كوستاريكا"
	},
	CY: {
		CountryCode: "+357",
		CountryName: "Cyprus",
		ISO_2Code: "CY",
		ISO_3Code: "CYP",
		CountryName_ar: "قبرص"
	},
	CZ: {
		CountryCode: "+420",
		CountryName: "Czech Republic",
		ISO_2Code: "CZ",
		ISO_3Code: "CZE",
		CountryName_ar: "الجمهورية التشيكية"
	},
	DK: {
		CountryCode: "+45",
		CountryName: "Denmark",
		ISO_2Code: "DK",
		ISO_3Code: "DNK",
		CountryName_ar: "الدانمارك"
	},
	DO: {
		CountryCode: "+1",
		CountryName: "Dominican Republic",
		ISO_2Code: "DO",
		ISO_3Code: "DOM",
		CountryName_ar: "الدومينيكان"
	},
	EG: {
		CountryCode: "+20",
		CountryName: "Egypt",
		ISO_2Code: "EG",
		ISO_3Code: "EGY",
		CountryName_ar: "مصر"
	},
	SV: {
		CountryCode: "+503",
		CountryName: "El Salvador",
		ISO_2Code: "SV",
		ISO_3Code: "SLV",
		CountryName_ar: "إلسلفادور"
	},
	FO: {
		CountryCode: "+298",
		CountryName: "Faroe Islands",
		ISO_2Code: "FO",
		ISO_3Code: "FRO",
		CountryName_ar: "جزر فارو"
	},
	FI: {
		CountryCode: "+358",
		CountryName: "Finland",
		ISO_2Code: "FI",
		ISO_3Code: "FIN",
		CountryName_ar: "فنلندا"
	},
	FR: {
		CountryCode: "+33",
		CountryName: "France",
		ISO_2Code: "FR",
		ISO_3Code: "FRA",
		CountryName_ar: "فرنسا"
	},
	GF: {
		CountryCode: "+594",
		CountryName: "French Guiana",
		ISO_2Code: "GF",
		ISO_3Code: "GUF",
		CountryName_ar: "غويانا الفرنسية"
	},
	DE: {
		CountryCode: "+49",
		CountryName: "Germany",
		ISO_2Code: "DE",
		ISO_3Code: "DEU",
		CountryName_ar: "ألمانيا"
	},
	GI: {
		CountryCode: "+350",
		CountryName: "Gibraltar",
		ISO_2Code: "GI",
		ISO_3Code: "GIB",
		CountryName_ar: "جبل طارق"
	},
	GR: {
		CountryCode: "+30",
		CountryName: "Greece",
		ISO_2Code: "GR",
		ISO_3Code: "GRC",
		CountryName_ar: "اليونان"
	},
	GP: {
		CountryCode: "+590",
		CountryName: "Guadeloupe",
		ISO_2Code: "GP",
		ISO_3Code: "GLP",
		CountryName_ar: "جزر جوادلوب"
	},
	GU: {
		CountryCode: "+1",
		CountryName: "Guam",
		ISO_2Code: "GU",
		ISO_3Code: "GUM",
		CountryName_ar: "جوام"
	},
	GT: {
		CountryCode: "+502",
		CountryName: "Guatemala",
		ISO_2Code: "GT",
		ISO_3Code: "GTM",
		CountryName_ar: "غواتيمال"
	},
	GY: {
		CountryCode: "+592",
		CountryName: "Guyana",
		ISO_2Code: "GY",
		ISO_3Code: "GUY",
		CountryName_ar: "غيانا"
	},
	HK: {
		CountryCode: "+852",
		CountryName: "Hong Kong",
		ISO_2Code: "HK",
		ISO_3Code: "HKG",
		CountryName_ar: "هونغ كونغ"
	},
	HU: {
		CountryCode: "+36",
		CountryName: "Hungary",
		ISO_2Code: "HU",
		ISO_3Code: "HUN",
		CountryName_ar: "المجر"
	},
	IS: {
		CountryCode: "+354",
		CountryName: "Iceland",
		ISO_2Code: "IS",
		ISO_3Code: "ISL",
		CountryName_ar: "آيسلندا"
	},
	IN: {
		CountryCode: "+91",
		CountryName: "India",
		ISO_2Code: "IN",
		ISO_3Code: "IND",
		CountryName_ar: "الهند"
	},
	ID: {
		CountryCode: "+62",
		CountryName: "Indonesia",
		ISO_2Code: "ID",
		ISO_3Code: "IDN",
		CountryName_ar: "أندونيسيا"
	},
	IR: {
		CountryCode: "+98",
		CountryName: "Iran",
		ISO_2Code: "IR",
		ISO_3Code: "IRN",
		CountryName_ar: "إيران"
	},
	IE: {
		CountryCode: "+353",
		CountryName: "Ireland",
		ISO_2Code: "IE",
		ISO_3Code: "IRL",
		CountryName_ar: "أيرلندا"
	},
	IT: {
		CountryCode: "+39",
		CountryName: "Italy",
		ISO_2Code: "IT",
		ISO_3Code: "ITA",
		CountryName_ar: "إيطاليا"
	},
	JP: {
		CountryCode: "+81",
		CountryName: "Japan",
		ISO_2Code: "JP",
		ISO_3Code: "JPN",
		CountryName_ar: "اليابان"
	},
	JO: {
		CountryCode: "+962",
		CountryName: "Jordan",
		ISO_2Code: "JO",
		ISO_3Code: "JOR",
		CountryName_ar: "الأردن"
	},
	KE: {
		CountryCode: "+254",
		CountryName: "Kenya",
		ISO_2Code: "KE",
		ISO_3Code: "KEN",
		CountryName_ar: "كينيا"
	},
	KW: {
		CountryCode: "+965",
		CountryName: "Kuwait",
		ISO_2Code: "KW",
		ISO_3Code: "KWT",
		CountryName_ar: "الكويت"
	},
	LA: {
		CountryCode: "+856",
		CountryName: "Lao People's Democratic Republic",
		ISO_2Code: "LA",
		ISO_3Code: "LAO",
		CountryName_ar: "Lao People's Democratic Republic"
	},
	LB: {
		CountryCode: "+961",
		CountryName: "Lebanon",
		ISO_2Code: "LB",
		ISO_3Code: "LBN",
		CountryName_ar: "لبنان"
	},
	LU: {
		CountryCode: "+352",
		CountryName: "Luxembourg",
		ISO_2Code: "LU",
		ISO_3Code: "LUX",
		CountryName_ar: "لوكسمبورغ"
	},
	MO: {
		CountryCode: "+853",
		CountryName: "Macao",
		ISO_2Code: "MO",
		ISO_3Code: "MAC",
		CountryName_ar: "ماكاو"
	},
	MY: {
		CountryCode: "+60",
		CountryName: "Malaysia",
		ISO_2Code: "MY",
		ISO_3Code: "MYS",
		CountryName_ar: "ماليزيا"
	},
	MT: {
		CountryCode: "+356",
		CountryName: "Malta",
		ISO_2Code: "MT",
		ISO_3Code: "MLT",
		CountryName_ar: "مالطا"
	},
	MH: {
		CountryCode: "+692",
		CountryName: "Marshall Islands",
		ISO_2Code: "MH",
		ISO_3Code: "MHL",
		CountryName_ar: "جزر مارشال"
	},
	MQ: {
		CountryCode: "+596",
		CountryName: "Martinique",
		ISO_2Code: "MQ",
		ISO_3Code: "MTQ",
		CountryName_ar: "مارتينيك"
	},
	MU: {
		CountryCode: "+230",
		CountryName: "Mauritius",
		ISO_2Code: "MU",
		ISO_3Code: "MUS",
		CountryName_ar: "موريشيوس"
	},
	YT: {
		CountryCode: "+262",
		CountryName: "Mayotte",
		ISO_2Code: "YT",
		ISO_3Code: "MYT",
		CountryName_ar: "مايوتي"
	},
	MX: {
		CountryCode: "+52",
		CountryName: "Mexico",
		ISO_2Code: "MX",
		ISO_3Code: "MEX",
		CountryName_ar: "المكسيك"
	},
	MN: {
		CountryCode: "+976",
		CountryName: "Mongolia",
		ISO_2Code: "MN",
		ISO_3Code: "MNG",
		CountryName_ar: "منغوليا"
	},
	NA: {
		CountryCode: "+264",
		CountryName: "Namibia",
		ISO_2Code: "NA",
		ISO_3Code: "NAM",
		CountryName_ar: "ناميبيا"
	},
	NP: {
		CountryCode: "+977",
		CountryName: "Nepal",
		ISO_2Code: "NP",
		ISO_3Code: "NPL",
		CountryName_ar: "نيبال"
	},
	NL: {
		CountryCode: "+31",
		CountryName: "Netherlands",
		ISO_2Code: "NL",
		ISO_3Code: "NLD",
		CountryName_ar: "هولندا"
	},
	NC: {
		CountryCode: "+687",
		CountryName: "New Caledonia",
		ISO_2Code: "NC",
		ISO_3Code: "NCL",
		CountryName_ar: "New Caledonia"
	},
	NZ: {
		CountryCode: "+64",
		CountryName: "New Zealand",
		ISO_2Code: "NZ",
		ISO_3Code: "NZL",
		CountryName_ar: "نيوزيلندا"
	},
	NG: {
		CountryCode: "+234",
		CountryName: "Nigeria",
		ISO_2Code: "NG",
		ISO_3Code: "NGA",
		CountryName_ar: "نيجيريا"
	},
	NO: {
		CountryCode: "+47",
		CountryName: "Norway",
		ISO_2Code: "NO",
		ISO_3Code: "NOR",
		CountryName_ar: "النرويج"
	},
	OM: {
		CountryCode: "+968",
		CountryName: "Oman",
		ISO_2Code: "OM",
		ISO_3Code: "OMN",
		CountryName_ar: "عُمان"
	},
	PK: {
		CountryCode: "+92",
		CountryName: "Pakistan",
		ISO_2Code: "PK",
		ISO_3Code: "PAK",
		CountryName_ar: "باكستان"
	},
	PS: {
		CountryCode: "+970",
		CountryName: "Palestine",
		ISO_2Code: "PS",
		ISO_3Code: "PSE",
		CountryName_ar: "فلسطين"
	},
	PA: {
		CountryCode: "+507",
		CountryName: "Panama",
		ISO_2Code: "PA",
		ISO_3Code: "PAN",
		CountryName_ar: "بنما"
	},
	PY: {
		CountryCode: "+595",
		CountryName: "Paraguay",
		ISO_2Code: "PY",
		ISO_3Code: "PRY",
		CountryName_ar: "باراغواي"
	},
	PE: {
		CountryCode: "+51",
		CountryName: "Peru",
		ISO_2Code: "PE",
		ISO_3Code: "PER",
		CountryName_ar: "بيرو"
	},
	PH: {
		CountryCode: "+63",
		CountryName: "Philippines",
		ISO_2Code: "PH",
		ISO_3Code: "PHL",
		CountryName_ar: "الفليبين"
	},
	PL: {
		CountryCode: "+48",
		CountryName: "Poland",
		ISO_2Code: "PL",
		ISO_3Code: "POL",
		CountryName_ar: "بولندا"
	},
	PT: {
		CountryCode: "+351",
		CountryName: "Portugal",
		ISO_2Code: "PT",
		ISO_3Code: "PRT",
		CountryName_ar: "البرتغال"
	},
	PR: {
		CountryCode: "+1",
		CountryName: "Puerto Rico",
		ISO_2Code: "PR",
		ISO_3Code: "PRI",
		CountryName_ar: "بورتوريكو"
	},
	QA: {
		CountryCode: "+974",
		CountryName: "Qatar",
		ISO_2Code: "QA",
		ISO_3Code: "QAT",
		CountryName_ar: "قطر"
	},
	RE: {
		CountryCode: "+262",
		CountryName: "Réunion",
		ISO_2Code: "RE",
		ISO_3Code: "REU",
		CountryName_ar: "Réunion"
	},
	RO: {
		CountryCode: "+40",
		CountryName: "Romania",
		ISO_2Code: "RO",
		ISO_3Code: "ROU",
		CountryName_ar: "رومانيا"
	},
	RU: {
		CountryCode: "+7",
		CountryName: "Russia",
		ISO_2Code: "RU",
		ISO_3Code: "RUS",
		CountryName_ar: "Russia"
	},
	SA: {
		CountryCode: "+966",
		CountryName: "Saudi Arabia",
		ISO_2Code: "SA",
		ISO_3Code: "SAU",
		CountryName_ar: "المملكة العربية السعودية"
	},
	SG: {
		CountryCode: "+65",
		CountryName: "Singapore",
		ISO_2Code: "SG",
		ISO_3Code: "SGP",
		CountryName_ar: "سنغافورة"
	},
	SK: {
		CountryCode: "+421",
		CountryName: "Slovakia",
		ISO_2Code: "SK",
		ISO_3Code: "SVK",
		CountryName_ar: "سلوفاكيا"
	},
	ZA: {
		CountryCode: "+27",
		CountryName: "South Africa",
		ISO_2Code: "ZA",
		ISO_3Code: "ZAF",
		CountryName_ar: "جنوب أفريقيا"
	},
	KR: {
		CountryCode: "+82",
		CountryName: "South Korea",
		ISO_2Code: "KR",
		ISO_3Code: "KOR",
		CountryName_ar: "كوريا الجنوبية"
	},
	ES: {
		CountryCode: "+34",
		CountryName: "Spain",
		ISO_2Code: "ES",
		ISO_3Code: "ESP",
		CountryName_ar: "إسبانيا"
	},
	LK: {
		CountryCode: "+94",
		CountryName: "Sri Lanka",
		ISO_2Code: "LK",
		ISO_3Code: "LKA",
		CountryName_ar: "سريلانكا"
	},
	SD: {
		CountryCode: "+249",
		CountryName: "Sudan",
		ISO_2Code: "SD",
		ISO_3Code: "SDN",
		CountryName_ar: "السودان"
	},
	SZ: {
		CountryCode: "+268",
		CountryName: "Swaziland",
		ISO_2Code: "SZ",
		ISO_3Code: "SWZ",
		CountryName_ar: "سوازيلند"
	},
	SE: {
		CountryCode: "+46",
		CountryName: "Sweden",
		ISO_2Code: "SE",
		ISO_3Code: "SWE",
		CountryName_ar: "السويد"
	},
	CH: {
		CountryCode: "+41",
		CountryName: "Switzerland",
		ISO_2Code: "CH",
		ISO_3Code: "CHE",
		CountryName_ar: "سويسرا"
	},
	SY: {
		CountryCode: "+963",
		CountryName: "Syria",
		ISO_2Code: "SY",
		ISO_3Code: "SYR",
		CountryName_ar: "سوريا"
	},
	TW: {
		CountryCode: "+886",
		CountryName: "Taiwan",
		ISO_2Code: "TW",
		ISO_3Code: "TWN",
		CountryName_ar: "تايوان"
	},
	TJ: {
		CountryCode: "+992",
		CountryName: "Tajikistan",
		ISO_2Code: "TJ",
		ISO_3Code: "TJK",
		CountryName_ar: "طاجيكستان"
	},
	TH: {
		CountryCode: "+66",
		CountryName: "Thailand",
		ISO_2Code: "TH",
		ISO_3Code: "THA",
		CountryName_ar: "تايلاند"
	},
	TR: {
		CountryCode: "+90",
		CountryName: "Turkey",
		ISO_2Code: "TR",
		ISO_3Code: "TUR",
		CountryName_ar: "ديك رومي"
	},
	TM: {
		CountryCode: "+993",
		CountryName: "Turkmenistan",
		ISO_2Code: "TM",
		ISO_3Code: "TKM",
		CountryName_ar: "تركمانستان"
	},
	GB: {
		CountryCode: "+44",
		CountryName: "United Kingdom",
		ISO_2Code: "GB",
		ISO_3Code: "GBR",
		CountryName_ar: "المملكة المتحدة"
	},
	US: {
		CountryCode: "+1",
		CountryName: "United States",
		ISO_2Code: "US",
		ISO_3Code: "USA",
		CountryName_ar: "الولايات المتحدة"
	},
	UY: {
		CountryCode: "+598",
		CountryName: "Uruguay",
		ISO_2Code: "UY",
		ISO_3Code: "URY",
		CountryName_ar: "أوروغواي"
	},
	UZ: {
		CountryCode: "+998",
		CountryName: "Uzbekistan",
		ISO_2Code: "UZ",
		ISO_3Code: "UZB",
		CountryName_ar: "أوزبكستان"
	},
	VN: {
		CountryCode: "+84",
		CountryName: "Vietnam",
		ISO_2Code: "VN",
		ISO_3Code: "VNM",
		CountryName_ar: "Vietnam"
	},
	VI: {
		CountryCode: "+1",
		CountryName: "Virgin Islands (U.S.)",
		ISO_2Code: "VI",
		ISO_3Code: "VIR",
		CountryName_ar: "Virgin Islands (U.S.)"
	},
	YE: {
		CountryCode: "+967",
		CountryName: "Yemen",
		ISO_2Code: "YE",
		ISO_3Code: "YEM",
		CountryName_ar: "اليمن"
	}
};

let sortedCountryCodes = Object.keys(CountriesList);

let Countries = {
	Countries: CountriesList,
	sortedCountryCodes: sortedCountryCodes
};

export default Countries;
